var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "metadata" }, [
    _c("div", { staticClass: "description" }, [
      _c("label", { attrs: { for: "question_explanation" } }, [_vm._v("解説")]),
      _c("br"),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.explanation,
            expression: "explanation",
          },
        ],
        staticClass: "form-control",
        attrs: { id: "question_explanation" },
        domProps: { value: _vm.explanation },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.explanation = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "add-skill" }, [
      _c("label", { attrs: { for: "new-skill" } }, [_vm._v("スキルの追加")]),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "input-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newSkillName,
              expression: "newSkillName",
            },
          ],
          staticClass: "form-control",
          domProps: { value: _vm.newSkillName },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.newSkillName = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "input-group-btn" }, [
          _c(
            "button",
            {
              staticClass: "form-control",
              on: {
                click: function ($event) {
                  return _vm.addNewSkill()
                },
              },
            },
            [_vm._v("追加")]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "skill-detail" },
      _vm._l(_vm.skills, function (skill) {
        return _c(
          "li",
          { key: skill.id },
          [_c("SkillComponent", { attrs: { skill: skill } })],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }